module.exports = __webpack_public_path__ + "img/chat.aeab4b9e.svg";